// @ts-nocheck
import React, { useEffect } from 'react';
import Button from '@material/react-button';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import login_bg from 'assets/img/login_bg.png';
import logo from 'assets/img/login-logo.png';
import useSave from 'hooks/useSave';
import useToast from 'hooks/useToast';
import { LOGIN_API } from 'config/constants';
import InputField from 'components/atoms/InputField';
import {
  EmailIcon,
  LockOutlinedIcon,
  VisibilityIcon,
  VisibilityOffIcon,
} from 'assets/icons';
import { common, secondary } from 'assets/colors/colors';
import { Checkbox } from 'components/base';
import { Logger } from 'utils/logger';

function LoginWrapper() {
  const toast = useToast();
  const navigate = useNavigate();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: '/' } };

  useEffect(() => {
    localStorage.removeItem('tenant');
  }, []);

  const [login, { loading, error }] = useSave(LOGIN_API, {
    onSuccess(data) {
      localStorage.setItem('token', data.access);
      localStorage.setItem('refresh', data.refresh);
      localStorage.setItem('user_id', data.user_id);
      localStorage.removeItem('_expiredTime');
      localStorage.removeItem('beta_mode');
      const d = new Date();
      d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
      const apiKey = import.meta.env.VITE_APP_BASE_URL;
      document.cookie = `md6_var_profile=0254610a2767b1eeb162e6d57ce9b390; expires=${d.toUTCString()}; domain=${apiKey};`;
      toast.success('Login Successful');
      navigate(from);
    },
    onFailure(err) {
      toast.error(err);
    },
  });

  return <Login {...{ userLogin: login, loading, errorResponse: error }} />;
}

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: '',
        password: '',
        remember: false,
      },
      errors: {
        usernameErr: '',
        passwordErr: '',
      },
      showPassword: false,
    };
  }

  handleOnChange = (e) => {
    const {
      target: { name, value },
    } = e;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
      errors: {
        ...this.state.errors,
        [`${name}Err`]: '',
      },
    });
  };

  handleRememeberMe = (e) => {
    const {
      target: { checked },
    } = e;

    this.setState(
      {
        data: {
          ...this.state.data,
          remember: checked,
        },
      },
      () => {
        if (this.state.data.remember) {
          localStorage.setItem('user', this.state.data.username);
        } else {
          localStorage.removeItem('user');
        }
      },
    );
  };

  handlePasswordChecked = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  hanldeValidation = () => {
    const { data } = this.state;
    const errors = {};
    if (!data.username) errors.usernameErr = 'Email is required.';
    if (!data.password) errors.passwordErr = 'Password is required.';

    return errors;
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const errors = this.hanldeValidation();
    this.setState({
      errors,
    });
    if (Object.keys(errors).length === 0) {
      this.props.userLogin(this.state.data);
    } else {
      Logger.error({ message: 'error in login', data: errors });
    }
  };

  componentDidMount() {
    const username = localStorage.getItem('user');
    if (username) {
      this.setState({
        data: {
          ...this.state.data,
          username,
          remember: true,
        },
      });
    }
  }

  render() {
    const { data, errors, showPassword } = this.state;
    const { loading } = this.props;
    return (
      <div
        className="authentication parallax-container"
        style={{ backgroundImage: `url(${login_bg})` }}
      >
        <div className="container">
          <div className="card auth_form">
            <div className="login-logo">
              <img
                className="logo"
                src={logo}
                alt=""
                style={{ width: '164px', height: '62px' }}
              />
            </div>
            <div className="body">
              <div className="login-header">
                <h5>Log in to your account</h5>
              </div>
              <form onSubmit={this.handleSubmit}>
                {/* new fields */}
                <div className="form-group">
                  <InputField
                    type="text"
                    style={{ margin: 0 }}
                    label="Email *"
                    name="username"
                    startAdornment={
                      <EmailIcon
                        sx={{ color: common.icon, fontSize: '18px' }}
                      />
                    }
                    value={data.username || ''}
                    onChange={this.handleOnChange}
                  />
                  {errors.usernameErr && (
                    <span className="error">{errors.usernameErr}</span>
                  )}
                </div>
                <div className="form-group">
                  <InputField
                    style={{ margin: 0 }}
                    label="Password *"
                    name="password"
                    startAdornment={
                      <LockOutlinedIcon
                        sx={{ color: common.icon, fontSize: '18px' }}
                      />
                    }
                    type={showPassword ? 'text' : 'password'}
                    value={data.password || ''}
                    onChange={this.handleOnChange}
                    endAdornment={
                      showPassword ? (
                        <VisibilityOffIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                          onClick={this.handlePasswordChecked}
                        />
                      ) : (
                        <VisibilityIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                          onClick={this.handlePasswordChecked}
                        />
                      )
                    }
                  />
                  {errors.passwordErr && (
                    <span className="error">{errors.passwordErr}</span>
                  )}
                </div>
                {/* new fields */}
                <div className="form-group checkbox">
                  <Checkbox
                    sx={{
                      color: data.remember ? secondary.main : common.icon,
                    }}
                    value=""
                    checked={data.remember}
                    onChange={this.handleRememeberMe}
                  />
                  <label htmlFor="my-checkbox">Remember Me</label>
                </div>
                <div className="form-group">
                  <Button raised type="submit" disabled={loading}>
                    log in
                  </Button>
                </div>
                <div className="login-footer">
                  {/* <Link to="/signup">Create Account</Link> */}

                  <Link to="/forgot-password">Forgot password ?</Link>
                </div>
              </form>
            </div>
            <div className="privacy">
              <a
                href="https://varicon.com.au/privacy-policy/"
                target="_blank"
                style={{ color: '#5F6D83' }}
              >
                Privacy policy
              </a>
              <a
                href="https://varicon.com.au/end-user-license-agreement/"
                target="_blank"
                style={{ color: '#5F6D83' }}
              >
                Terms of use
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoginWrapper;
